export const queryKeys = {
  PAYLOV_CONFIG: 'PAYLOV_CONFIG'
};
